import { render, staticRenderFns } from "./ServiceModal.vue?vue&type=template&id=68f37c04&scoped=true&"
import script from "./ServiceModal.vue?vue&type=script&lang=js&"
export * from "./ServiceModal.vue?vue&type=script&lang=js&"
import style0 from "./ServiceModal.vue?vue&type=style&index=0&id=68f37c04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f37c04",
  null
  
)

export default component.exports